module.exports = __webpack_public_path__ + "img/f-thermometer-img7-2.5f9a363a.jpg";